<div class="table-responsive row">
  <table class="table table-bordered table-hover">
    <thead class="thead-lg">
      <tr>
        <th>#</th>
        <th (click)="onSort('name')">CONTACT DETAILS</th>
        <th (click)="onSort('position')">POSITION</th>
        <th (click)="onSort('compid')">COMPANY NAME</th>
        <th (click)="onSort('comcard')">LOCATION</th>
        <th (click)="onSort('dt_checkin')">VISITED ON</th>
        <th (click)="onSort('temp')">REMARK</th>
      </tr>
    </thead>
    <!-- <tbody>
      <tr>
        <td>holaa</td>
      </tr>
      <tr>
        <td>holaa</td>
      </tr>
      <tr>
        <td>holaa</td>
      </tr>
      <tr>
        <td>holaa</td>
      </tr>
      <tr>
        <td>holaa</td>
      </tr>
      <tr>
        <td>holaa</td>
      </tr>
      <tr>
        <td>holaa</td>
      </tr>
    </tbody> -->
  </table>

  <!-- <div class="table-end-btn">
    <div>
      <ngb-pagination (pageChange)="getPageFromService($event)"
      [pageSize]="pageSize" [(page)]="page" [maxSize]="5" [rotate]="true" [collectionSize]="totalrows"></ngb-pagination>
    </div>
  </div> -->
</div>